import {
  Component,
  HostListener,
  inject,
  OnDestroy,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ButtonComponent, ChatButtonComponent, ModalComponent } from '@webapp/ui';
import { IQuoterQuote } from '../../../interfaces/quoter.interface';
import { QuoterStoreService } from '../../../store/quoter-store.service';
import { QuoterInsurableService } from '../../../services/quoter-insurable.service';
import { QuoterSidebarCoverageComponent } from '../../components/quoter-sidebar-coverage/quoter-sidebar-coverage.component';
import { SelectedAgentComponent } from '../../components/selected-agent/selected-agent.component';
import { ShowForChannelDirective } from '@webapp/core/directives/showForChannel';
import { QUOTER_ROUTE_PATH } from '@webapp/core';
import { CLIENT_DASHBOARD_ROUTE_PATH } from '@webapp/core/constants/client-routes';
import { AuthService, UserRole } from '@webapp/auth';

@Component({
  selector: 'app-quoter-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    ButtonComponent,
    ModalComponent,
    SelectedAgentComponent,
    ShowForChannelDirective,
    ChatButtonComponent,
    QuoterSidebarCoverageComponent,
  ],
  templateUrl: './quoter-layout.component.html',
  styleUrl: './quoter-layout.component.scss',
})
export class QuoterLayoutComponent implements OnDestroy {
  isLoading = false;
  isModalOpen = false;
  errors: string[] = [];
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private quoterStateService = inject(QuoterStoreService);
  private quoterInsurableService = inject(QuoterInsurableService);
  private authService = inject(AuthService);
  readonly quoterState = this.quoterStateService.state.asReadonly();
  quoteResult = signal<IQuoterQuote>({} as IQuoterQuote);

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnloadHandler(e: BeforeUnloadEvent) {
    e.preventDefault();
  }

 
  openModal() {
    this.quoterStateService.set('isLeavingModal', true);
  }

  closeModal() {
    this.quoterStateService.set('isLeavingModal', false);
  }

  
  closeQuoter() {
    this.quoterStateService.set('hasUnsavedChanges', false);
    this.quoterStateService.set('isLeavingModal', false);
    this.quoterInsurableService.clearAll();
    this.quoterStateService.initializeState();

    const isLoggedInClient =
      this.authService.isAuthenticated() &&
      this.authService.user()?.role === UserRole.CLIENT;

    this.router.navigate([isLoggedInClient ? CLIENT_DASHBOARD_ROUTE_PATH : QUOTER_ROUTE_PATH]);
  }

  async downloadQuoteProposal() {
    try {
      await this.quoterStateService.downloadQuoteProposal();
    } catch (error: unknown) {
      console.error(`Error al descargar la cotización: ${error}`);
    }
  }

  getCoverage() {
    return this.quoterState()?.quote?.additionalCoverage;
  }

  ngOnDestroy(): void {
    this.quoterStateService.set('hasUnsavedChanges', false);
    this.quoterStateService.set('isLeavingModal', false);
    this.quoterInsurableService.clearAll();
    this.quoterStateService.initializeState();
  }
}
